import { defineStore } from "pinia";
import Echo from "@/services/echo"; // الـ echo.js اللي عاملناه للويب سوكيت

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    notifications: [],
    unreadCount: 0,
  }),
  actions: {
    init(userId) {
      // الاشتراك في قناة المستخدم الخاصة
      Echo.private(`user.${userId}`).listen("BookingCreated", (payload) => {
        console.log("🎉 Received notification:", payload);
        this.notifications.unshift({
          id: payload.id,
          title: payload.car?.model_name
            ? `Booking: ${payload.car.model_name}`
            : "New Booking",
          body: `تم إنشاء الحجز بواسطة ${payload.user?.name || "مستخدم"}`,
          created_at: payload.created_at,
          is_read: false,
        });
        this.unreadCount++;
      });
    },
    markAsRead(notificationId) {
      const notif = this.notifications.find((n) => n.id === notificationId);
      if (!notif) return;
      notif.is_read = true;
      this.unreadCount = this.notifications.filter((n) => !n.is_read).length;
    },
  },
});
